import { render, staticRenderFns } from "./CompanyUsersPage.vue?vue&type=template&id=cef3da8c&"
import script from "./CompanyUsersPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyUsersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports